module.exports = {
      id: "icon-config-list-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#icon-config-list",
      toString: function () {
        return this.url;
      }
    }